import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M7 20h8l-4 -4v-7l4 3l2 -2","key":"svg-1"}]]

const IconPray = createReactComponent('outline', 'pray', 'Pray', __iconNode);

export default IconPray;